/**
 * Propiedades por defecto para asegurar que el sitio siempre cargue
 * contenido rico y funcional aún sin conexión o si el backend está inactivo.
 */
export const DEFAULT_PROPERTIES = [
  {
    id: 9,
    titulo: "Huatulco, Oax Loft 222, Punta Gaviota con vista al mar",
    categoria: "Playa",
    precio: "4877",
    rating: "4.5",
    img: "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771685981/casas-ernestina/fyhqmdx78fhjq3bxvd18.jpg",
    galeria: [
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/j3itxodhhivg8gxyyp3w.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/j0mmycd4trlsqzcjqu1p.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/quaxjrreay2sa4tbibsk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/nfhh4nwzb28qmil4rrd4.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/juoocapuckejcvtwc4wi.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/slys3e3vxp1ipnazxuxw.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/pv8mpdxqoswlrl7k8uwl.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705090/casas-ernestina/gallery/rsqpkn4i5edqlg8qbap9.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/wzcks9k2no9eifxsfia1.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/fghi4gsmu1dup2cmnhg9.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/rsxlet64xrretcwyxdyr.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/kxcihiou9dlrw8snywqj.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/v2nvyytulqojawekvcgv.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771705122/casas-ernestina/gallery/gasp6ke2c5mcogbvxqx0.jpg"
    ],
    ubicacion: "Huatulco, Oaxaca",
    mapa_embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2384.2301586106964!2d-96.10620528966164!3d15.762818572396764!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85bf21893c184a0b%3A0xa3b82897f4c56d53!2sPunta%20Gaviota%20Ocean%20Views.!5e0!3m2!1ses!2smx!4v1771685911678!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    descripcion: "Ideal para grupos o viajes en familia. Sumérgete en la serenidad de nuestra casa, un refugio idílico con vista al mar y la naturaleza. Diseñada para alojar hasta cuatro personas, nuestra propiedad cuenta con dos acogedoras habitaciones, que garantizarán tu descanso y confort.",
    huespedes: 4,
    dormitorios: 2,
    banios: 1,
    amenidades: ["Wifi", "Alberca", "Cocina"],
    created_at: "2026-02-21 14:59:42",
    updated_at: "2026-02-21 20:18:44"
  },
  {
    id: 12,
    titulo: "Huatulco, Oax loft en El Arrocito",
    categoria: "Playa",
    precio: "1",
    rating: "5.0",
    img: "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718604/casas-ernestina/ntbty51nhhrpzzghscoh.jpg",
    galeria: [
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/m98m3zlsxvrdhgrsndxa.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/cos7nnutp53kjii9pwqk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/mtlq8nur2gv0hajl4o0g.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/trzrukzct5vzoaf6lhqy.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/dh8nhkj58fipm3jwbxkj.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/kpaff4vozjmcxhjvy2dn.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718606/casas-ernestina/gallery/qwwf4jf2s3gdg78hdrne.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/gs4dr0wmji7n1oxqfpsk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/feitfzsbulh6733h7lxd.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/knqjakbuv3t2hsairoe8.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/dy6cxntkpei1ajz82ydk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/itvwgpogj3j7liczfqo6.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/ynmjpnl8qqg9mmeekts6.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/ptd7iokjlpxoqcsukrc6.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718625/casas-ernestina/gallery/bacvz8ign5smdts9anoq.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/fesyh77ldss0unfzli9e.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718646/casas-ernestina/gallery/wazylxezzebzm65pwvrk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/vqyhuhakbrr34rxstiks.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/wv34tzyqnvi5cy5wmy46.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718646/casas-ernestina/gallery/zd3x4xsg6jaeguzhqjii.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/fbtlujzdh1ubtcnn5bdn.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/anwhkkr8sbh5ylopu8fx.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718645/casas-ernestina/gallery/xpxwrf5x8nem78gnm8rx.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/q2wtles1tv1czltcgew3.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/u0fcx8chtzjuurbplqix.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/fozeda9eacgifqjivatv.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/clbknwjeguafsllfxxkt.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718667/casas-ernestina/gallery/gyi6zm1ld0joyrdqyb7q.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/whhiqdvkijplytyv9bmk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718668/casas-ernestina/gallery/pigtdrdfjn0tui5gudt9.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771718667/casas-ernestina/gallery/tfay5kgvlpfb7fmctrb1.jpg"
    ],
    ubicacion: "Huatulco, Oaxaca",
    mapa_embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d959.9431050028675!2d-96.106183!3d15.763174!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85bf21893c184a0b%3A0xa3b82897f4c56d53!2sPunta%20Gaviota%20Ocean%20Views.!5e0!3m2!1ses!2smx!4v1771718388489!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    descripcion: "Nuestro departamento en Punta Gaviota no solo te ofrece un lugar para quedarse, sino una experiencia completa de descanso y disfrute en una de las zonas más hermosas de Huatulco. Ya sea que vengas a desconectar y relajarte o a explorar la belleza natural de Oaxaca, nuestro alojamiento es la base perfecta para tu aventura.",
    huespedes: 6,
    dormitorios: 4,
    banios: 3,
    amenidades: [
      "Frente al agua",
      "Cocina",
      "Wifi",
      "Área para trabajar",
      "Estacionamiento gratuito en las instalaciones",
      "Alberca exterior compartida: disponible todo el año",
      "Jacuzzi",
      'Televisión HD con pantalla de 65" y Netflix',
      "Aire acondicionado",
      "Patio o balcón privado"
    ],
    created_at: "2026-02-22 00:03:28",
    updated_at: "2026-02-22 00:04:29"
  },
  {
    id: 13,
    titulo: "Huatulco, Oax Departamento Costa",
    categoria: "Playa",
    precio: "2",
    rating: "5.0",
    img: "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719942/casas-ernestina/lkpxbolzjzpzu6slvqd6.jpg",
    galeria: [
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719943/casas-ernestina/gallery/bl0s2am0rh3ielasycef.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/qqwvh0bu7wjbeo6e2bil.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/zhuesfuauk8pmvv9erl5.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719943/casas-ernestina/gallery/lm9uq9qayqwuidvcavgv.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/npnjquvnxgxr6l416eqx.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/qb9uneivqiltyojq2nvg.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719943/casas-ernestina/gallery/b9gmm8rzqgvcjvouacmr.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719943/casas-ernestina/gallery/vgqxurfhdrntvrpz5nxh.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/nsfvr1zkti1ektrsh7fv.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771719944/casas-ernestina/gallery/znd8wlkxl9imlyuiv9dx.jpg"
    ],
    ubicacion: "Huatulco, Oaxaca",
    mapa_embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d479.9600873301426!2d-96.14840280575348!3d15.768021820003888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85bf21e44c11394d%3A0x8ae885ce446c8084!2sDepa%20aline!5e0!3m2!1ses!2smx!4v1771719777184!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    descripcion: "Cómodo departamento para disfrutar tus vacaciones.",
    huespedes: 6,
    dormitorios: 2,
    banios: 1,
    amenidades: [
      "Sofá cama",
      "Cocina equipada",
      "Estufa",
      "Cafetera",
      "Refrigerador",
      "Aire acondicionado",
      "TV",
      "Wifi",
      "Boiler",
      "Patio de servicio",
      "Cajón de estacionamiento",
      "Seguridad 24 hrs."
    ],
    created_at: "2026-02-22 00:25:45",
    updated_at: "2026-02-22 00:25:45"
  },
  {
    id: 14,
    titulo: "Huatulco, Oax departamento Casa la primavera",
    categoria: "Playa",
    precio: "3",
    rating: "4.0",
    img: "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721120/casas-ernestina/l47r4acx7vwejupjxgtt.jpg",
    galeria: [
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/dydg74eiubo7c2a0ryqz.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/pxbnabng8p86lwl4ssoj.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/jtdsylereyquqocsu4hc.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/bddkpwdnhu1frjqtwlsy.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721122/casas-ernestina/gallery/qseilfpcdgv3t4yl3yhe.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/qwlr1xeuurcxwqhlx8a1.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721122/casas-ernestina/gallery/soljvqrauqqukwridmgq.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721121/casas-ernestina/gallery/v82qj8z6tjjfsajmwspy.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721133/casas-ernestina/gallery/tmmvceatqsn59wnge9ad.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721132/casas-ernestina/gallery/azqqnxo2m62xrwld1yal.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721132/casas-ernestina/gallery/r8pddkfaqewz63aydcif.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/xnyiplvrnbw38f5owks2.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/ma3q09qmiuqdmq7rdhbk.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/tw4n1tgax8tqkt7h5vo6.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/eokrbdr3oadolgmfybxc.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/tmv6gtyipcw1mfkd001p.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/fifoyir8uisq0wyofyhl.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/hecoqzb9hd7zcuswu7ni.jpg",
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771721143/casas-ernestina/gallery/vs3joeklgb7hspeqdugj.jpg"
    ],
    ubicacion: "Huatulco, Oaxaca",
    mapa_embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7406.516931436814!2d-96.1656101132679!3d15.783144618056848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85bf2787ee950247%3A0x58d1f125cb49d126!2sCasa%20la%20primavera!5e0!3m2!1ses!2smx!4v1771720330990!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    descripcion: "Departamentos perfectos para disfrutar tu viaje a Huatulco y descansar tranquilamente a 5 minutos del centro de la Crucecita y a 15 minutos de la playa.",
    huespedes: 16,
    dormitorios: 8,
    banios: 8,
    amenidades: [
      "3 terrazas",
      "Hamacas",
      "Cocina",
      "Comedor",
      "Sala de estar",
      "Alberca privada",
      "Habitaciones climatizadas c/u con baño completo",
      "Área de gimnasio",
      "Wifi",
      "Estacionamiento"
    ],
    created_at: "2026-02-22 00:45:23",
    updated_at: "2026-02-22 00:46:22"
  },
  {
    id: 15,
    titulo: "Huatulco, Oax Loft 222, Punta Gaviota con vista al mar",
    categoria: "Playa",
    precio: "2023",
    rating: "5.0",
    img: "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771987354/casas-ernestina/lciroit6ypyuephba3c7.jpg",
    galeria: [
      "https://res.cloudinary.com/dkrzgitcl/image/upload/v1771987354/casas-ernestina/lciroit6ypyuephba3c7.jpg"
    ],
    ubicacion: "Huatulco, Oaxaca",
    mapa_embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d953.3737980339724!2d-96.76667277154137!3d17.09732778081682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c71f467c9ae977%3A0x99c4aac3396b6bc9!2sC.%20Agamen%C3%B3n%203%2C%20Col%20Odisea%2C%2071220%20Santa%20Mar%C3%ADa%20Atzompa%2C%20Oax.!5e0!3m2!1ses-419!2smx!4v1771986032292!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    descripcion: "Hermoso loft en Punta Gaviota con vista espectacular al mar y todas las comodidades.",
    huespedes: 2,
    dormitorios: 1,
    banios: 1,
    amenidades: ["Wifi", "Alberca", "Cocina", "Vista al mar", "Aire acondicionado"],
    created_at: "2026-02-25 02:42:36",
    updated_at: "2026-02-25 02:42:36"
  }
];
